var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"backbox",class:_vm.isPC ? 'back-left': '',on:{"click":_vm.handleBackEvent}})])
}
var staticRenderFns = []

export { render, staticRenderFns }